import { render, staticRenderFns } from "./ChooseImage.vue?vue&type=template&id=a73afd38&scoped=true"
import script from "./ChooseImage.vue?vue&type=script&lang=js"
export * from "./ChooseImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73afd38",
  null
  
)

export default component.exports